<template>
<div>
    <Row type="flex" justify="end" style="margin-bottom: 40px;">
        <i-col>
            <i-select filterable clearable v-model="modulo" placeholder="Modulo" class="w-64 ml-2">
                <Option v-for="item in modulos" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <i-select filterable clearable v-model="funcao" v-if="modulo!=null" placeholder="Função" class="w-64 ml-2">
                <Option v-for="item in funcoes" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <i-select filterable clearable v-model="funcionalidade" v-if="funcao!=null && modulo!=null" placeholder="Funcionalidade" class="w-64 ml-2">
                <Option v-for="item in funcionalidades" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <i-select filterable clearable v-model="analista" placeholder="Analista" style="width:200px;margin-left:7px;">
                <Option v-for="item in analistas" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <i-select filterable clearable v-model="tipo" placeholder="Tipo de ticket" style="width:200px;margin-left:7px;">
                <Option v-for="item in tipos" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <InputNumber @input="carregarDados(false)" :active-change="false" :min="1" v-model="periodo" style="margin-left:7px;"></InputNumber>
            <i-switch @on-change="carregarDados(false)" false-value="mensal" size="large" style="margin: 7px 0 7px 7px;"
                        true-value="semanal" v-model="formato">
                <span slot="open">SEM</span>
                <span slot="close">MEN</span>
            </i-switch>
        </i-col>
    </Row>
    <bar-chart
        v-if="mostrar_grafico"
        :options="dados_grafico"
        @click="carregarTabela"
    />
    <Spin size="large" fix v-if="carregar"></Spin>
    <i-table v-if="mostrar_tabela" :columns="columns" :data="dados_modulos" :loading="carregar_tabela" class="mb-10"></i-table>
    <tickets-table v-if="mostrar_tabela" :csv="csv" :analistas="analistas" :loading="carregar_tabela"
        :tickets="tickets" 
        ocultarRelatores ocultarCadastros 
        ocultarObservacao ocultarFinalizados 
        exibirCriticidade exibirDetalhes
        exibirTempoDev exibirModulo>
    </tickets-table> 
</div>
</template>

<script>
    const {moment} = require("../../../helpers/utils.js")
    import accounting from "accounting"
    import _ from 'lodash'
    export default {
        components: {
            BarChart: () => import("../../../components/charts/BarChart.vue"),
        },
        props: {
            download: Boolean,
            refresh: Boolean,
            close: Boolean
        },
        data:()=>({
            modulo:null,
            modulos:[],
            funcao:null,
            funcoes:[],
            funcionalidade:null,
            funcionalidades:[],
            analista: null,
            tipo: null,
            status:null,
            periodo: 6,
            formato: 'semanal',
            tipos: [
                    {
                        label: "Bug",
                        value: 32
                    },
                    {
                        label: "Melhoria",
                        value: 33
                    },
                    {
                        label: "SS",
                        value: 35
                    },
                    {
                        label: "MVP",
                        value: 45
                    }
            ],
            dados: [],
            dados_grafico: {},
            mostrar_grafico:true,
            dentro_prazo:[],
            fora_prazo:[],
            carregar: false,
            mostrar_tabela: false,
            carregar_tabela: false,
            tickets:[],
            dados_modulos:[],
            columns:[
                {
                    title: "Modulo",
                    key: "modulo",
                    sortable: true,
                    render: (h, params) => {
                        return h("span",
                            [
                                params.row.treemodulo ? params.row.treemodulo.nome : 'Sem Modulo'
                            ]
                        )
                    }
                },
                {
                    title: "Função",
                    key: "funcao",
                    sortable: true,
                    render: (h, params) => {
                        return h("span",
                            [
                                params.row.treefuncao ? params.row.treefuncao.nome : 'Sem Função'
                            ]
                        )
                    }
                },
                {
                    title: "Total",
                    key: "total",
                    sortable: true,
                    align:'right'
                },
            ],
            csv:false,
            legenda:null,
        }),
        computed: {
            analistas() {
                let analistas = this.$store.getters['analistas']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }))
                return _.orderBy(analistas, ['label'],['asc'])
            },
        },
        methods: {
            async carregarDados(filtros) {
                this.carregar = true
                const URI = `ticket/estatisticas/produtividade`
                if (filtros) {
                    const {data} = await this.$axios.get(URI,{params: {formato:this.formato, periodo:this.periodo,filtros:filtros}})
                    this.dados = data.reverse().map(item =>{
                        return item.map(value => {
                            value["tempo_dev"] = 0
                            value["data_hora_fechamento"] = value["data_periodo"]
                            if(value.timeline){
                                value.timeline.map(timeline =>{
                                    value["tempo_dev"] = parseFloat(timeline.tempo_dev)
                                })
                            }
                            return value
                        })
                    })
                    this.legenda = this.caregarLegenda(data.length)
                    this.filtrarDados()
                    this.carregar = false
                } else {
                    const {data} = await this.$axios.get(URI,{params: {formato:this.formato,periodo:this.periodo}})
                    this.dados = data.reverse().map(item =>{
                        return item.map(value => {
                            value["tempo_dev"] = 0
                            value["data_hora_fechamento"] = value["data_periodo"]
                            if(value.timeline){
                                value.timeline.map(timeline =>{
                                    value["tempo_dev"] = parseFloat(timeline.tempo_dev)
                                })
                            }
                            return value
                        })
                    })
                    this.legenda = this.caregarLegenda(data.length)
                    this.modulo = null
                    this.funcao = null
                    this.funcionalidade = null
                    this.filtrarDados()
                    this.carregar = false
                }
            },

            filtrarDados() {
                let dados = this.filtros()
                this.mostrarDados([
                    dados.map((item) => this.filtrarPrazo(item,0)), 
                    dados.map((item) => this.filtrarPrazo(item,1)), 
                ])
            },

            filtros(){
                const analista = this.analista
                const tipo = this.tipo
                let dados = this.dados.map(item => item.filter(item => {
                        if (analista && tipo) {
                            return analista == item.id_pessoa && tipo == item.tipo_id
                        }
                        if (analista) {
                            return analista == item.id_pessoa
                        }
                        if (tipo) {
                            return tipo == item.tipo_id
                        }
                        return item
                }))
                return dados.map(item => item.filter(item => {
                    return !(item.status == 2 && item.andamento !=7)
                }))
            },

            filtrarPrazo(dados,prazo) {
                // filtro dos tickets que estao dentro do prazo
                if (prazo == 0){
                    dados = dados.filter(item => {
                        if (item.tempo_dev <= item.prazo) {
                            return !(item.status == 2 && item.andamento !=7)
                        }
                    })  
                    return dados 
                //  filtro dos tickets que estao fora do prazo  
                } else {
                    dados = dados.filter(item => {
                        if (item.tempo_dev > item.prazo) {
                            return !(item.status == 2 && item.andamento !=7)
                        }
                    }) 
                    return dados
                }      
            },

            carregarTabela(params) {
                this.mostrar_tabela = false
                setTimeout(() => {
                    if (!params.selected){
                        this.mostrar_tabela = true
                        this.carregar_tabela = true
                        let dados_modulos = []
                        if (params.seriesIndex == 0){
                            this.tickets =  this.dentro_prazo[params.dataIndex]
                            dados_modulos =  this.dentro_prazo[params.dataIndex].map(item =>{
                                item['id_funcao'] = item.treefuncao? item.treefuncao.id : -1
                                return item
                            })
                            let ids = dados_modulos.map(item =>{
                                return item.id_funcao
                            })
                            const totais = _.countBy(ids)
                            this.dados_modulos = _.unionBy(dados_modulos,'id_funcao').map(item =>{
                                item['total'] = totais[item.id_funcao]
                                return item
                            })
                        } else { 
                            if (params.seriesIndex == 1){
                                this.tickets = this.fora_prazo[params.dataIndex]
                                dados_modulos = this.fora_prazo[params.dataIndex].map(item =>{
                                    item['id_funcao'] = item.treefuncao? item.treefuncao.id : -1
                                    return item
                                })
                                let ids = dados_modulos.map(item =>{
                                    return item.id_funcao
                                })
                                const totais = _.countBy(ids)
                                this.dados_modulos = _.unionBy(dados_modulos,'id_funcao').map(item =>{
                                    item['total'] = totais[item.id_funcao]
                                    return item
                                })
                            } else {
                            if (params.seriesIndex == 2){
                                    this.tickets = this.filtros()[params.dataIndex]
                                    dados_modulos = this.filtros()[params.dataIndex].map(item =>{
                                        item['id_funcao'] = item.treefuncao? item.treefuncao.id : -1
                                        return item
                                    })
                                    let ids = dados_modulos.map(item =>{
                                        return item.id_funcao
                                    })
                                    const totais = _.countBy(ids)
                                    this.dados_modulos = _.unionBy(dados_modulos,'id_funcao').map(item =>{
                                        item['total'] = totais[item.id_funcao]
                                        return item
                                    })
                                }
                            }
                        }
                        this.carregar_tabela = false
                    } else {
                        this.mostrar_tabela = false
                    }
                }, 1);
            },

            mostrarDados([dentro_prazo,fora_prazo]){
                dentro_prazo = dentro_prazo.map(item=>
                    item.map(function(value) {
                        value['checkout'] = accounting.toFixed((value.prazo - value.tempo_dev),2)*1
                        return value
                    })
                )
                fora_prazo = fora_prazo.map(item=>
                    item.map(function(value) {
                        value['checkout'] = accounting.toFixed((value.prazo - value.tempo_dev),2)*1
                        return value
                    })
                )
                this.dentro_prazo = dentro_prazo
                this.fora_prazo = fora_prazo
                let tempo_dentro_prazo = dentro_prazo.map((item)=> ({
                    tempo_dev: item.reduce( ( prevVal, elem ) => prevVal + elem.tempo_dev, 0 ),
                    checkout: item.reduce( ( prevVal, elem ) => prevVal + elem.checkout, 0 ),
                    prazo: item.reduce( ( prevVal, elem ) => prevVal + elem.prazo, 0 ),
                }))
                let tempo_fora_prazo = fora_prazo.map((item)=> ({
                    tempo_dev: item.reduce( ( prevVal, elem ) => prevVal + elem.tempo_dev, 0 ),
                    checkout: item.reduce( ( prevVal, elem ) => prevVal + elem.checkout*-1, 0 ),
                    prazo: item.reduce( ( prevVal, elem ) => prevVal + elem.prazo, 0 ),
                }))
                const totais = this.filtros().map((value) => ({
                                value: value.length || 0,
                                itemStyle: {
                                    barBorderColor: '#FF1744',
                                }
                            }))
                this.dados_grafico = {
                    tooltip: {
                        type:'shadow',
                        formatter:(params)=>{
                            // condição para não mostrar tooltip na linha de totais
                            if (params.seriesIndex==0){
                                return `
                                    <span>${params.seriesName}</span><br>
                                    <span>${params.marker} Tickets: ${params.data.value}</span><br>
                                    <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FFDF20;"></span><span> Prazo: ${tempo_dentro_prazo[params.dataIndex].prazo} hs</span><br>
                                    <span ${params.marker} Tempo ganho: ${accounting.toFixed(tempo_dentro_prazo[params.dataIndex].checkout,2)} hs</span><br>
                                    <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#018ED4;"></span><span> Tempo: ${accounting.toFixed(tempo_dentro_prazo[params.dataIndex].tempo_dev,2)} hs</span>
                                `  
                            } else {
                                if (params.seriesIndex==1){
                                   return `
                                    <span>${params.seriesName}</span><br>
                                    <span>${params.marker} Tickets: ${params.data.value}</span><br>
                                    <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FFDF20;"></span><span> Prazo: ${tempo_fora_prazo[params.dataIndex].prazo} hs</span><br>
                                    <span ${params.marker} Tempo excedido: ${accounting.toFixed(tempo_fora_prazo[params.dataIndex].checkout,2)} hs</span><br>
                                    <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#018ED4;"></span><span> Tempo: ${accounting.toFixed(tempo_fora_prazo[params.dataIndex].tempo_dev,2)} hs</span>
                                `   
                                } else {
                                    return `
                                        <span>${params.seriesName}</span><br>
                                        <span>${params.marker} Tickets: ${params.data.value}</span><br>
                                        <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FFDF20;"></span><span> Prazo: ${tempo_dentro_prazo[params.dataIndex].prazo+tempo_fora_prazo[params.dataIndex].prazo} hs</span><br>
                                        <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00A595;"></span><span> Tempo ganho: ${accounting.toFixed(tempo_dentro_prazo[params.dataIndex].checkout,2)} hs</span><br>
                                        <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FF1744;"></span><span> Tempo excedido: ${accounting.toFixed(tempo_fora_prazo[params.dataIndex].checkout,2)} hs</span><br>
                                        <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#018ED4;"></span><span> Tempo: ${accounting.toFixed((tempo_dentro_prazo[params.dataIndex].tempo_dev+tempo_fora_prazo[params.dataIndex].tempo_dev),2)} hs</span>
                                    `
                                }
                            }
                        }
                    },
                    legend: {},
                    xAxis: {
                        data: this.legenda,
                        silent: false,
                        axisLine: {onZero: true},
                        splitArea: {show: false},
                        splitLine: {show: false}
                    },
                    yAxis: {},
                    grid: {
                        left: 50,
                        right: 50
                    },
                    label: {
                        position: 'top',
                        show: true,
                        formatter: (param) => param.value || '',
                    },
                    series: [
                        {
                            name: 'Dentro do prazo',
                            type: 'bar',
                            color: '#00A595',
                            data: dentro_prazo.map((value) => ({
                                value: value.length || '',
                                itemStyle: {
                                    barBorderColor: '#00A595',
                                }
                            })),
                        },
                        {
                            name: 'Fora do prazo',
                            type: 'bar',
                            color: '#FF1744',
                            data: fora_prazo.map((value) => ({
                                value: value.length || '',
                                itemStyle: {
                                    barBorderColor: '#FF1744',
                                }
                            })),
                        },
                        {
                            name: 'Totais',
                            type: 'line',
                            color: '#263238',
                            data: totais,
                        }
                    ]
                }
            },

            caregarLegenda(size) {
                let legenda = []
                if (this.formato === "semanal") {
                    legenda = ["Esta sem.", "1 sem. atrás"]
                    for (let i = 2; i < size; i++) {
                        legenda[i] = `${i} sem. atrás`
                    }
                } else {
                    for (let i = 0; i < size; i++) {
                        legenda[i] = moment().subtract(i, 'months').format("MMMM/YY")
                    }
                }
                return legenda.reverse()
            },

            async getModulos(){
                let modulos = await this.getChildren(1)
                this.modulos = _.orderBy(modulos, ['label'],['asc'])
            },

            async getChildren(id) {
                if (!id) return [];
                const {data: children} = await this.$axios.get(`tree/${id}/children`)
                return children.map(item => ({
                    value: item.id,
                    label: item.nome
                }))
            },
        },
        created() {
            this.getModulos()
            this.carregarDados(false)
        },
        watch: {
            refresh(){
                if (this.refresh){
                    this.modulo = null
                    this.funcao = null
                    this.funcionalidade = null
                    this.analista = null
                    this.tipo = null
                    this.status = null
                    this.formato = 'semanal'
                    this.periodo = 6
                    this.mostrar_tabela = false
                    this.carregarDados(false)
                }
            },
            download(){
                this.csv=this.download
            },
            async modulo(){
                if(this.modulo){
                    let funcoes = await this.getChildren(this.modulo)
                    this.funcoes = _.orderBy(funcoes, ['label'],['asc'])
                    this.carregarDados({treemodulo:this.modulo})
                    this.mostrar_tabela = false
                } else {
                    this.carregarDados(false)
                    this.mostrar_tabela = false
                }
            },
            async funcao(){
                if (this.funcao){
                    let funcionalidades = await this.getChildren(this.funcao)
                    this.funcionalidades = _.orderBy(funcionalidades, ['label'],['asc'])
                    this.carregarDados({treefuncao:this.funcao})
                    this.mostrar_tabela = false
                } else {
                    this.carregarDados({treemodulo:this.modulo})
                    this.mostrar_tabela = false
                }
            },
            async funcionalidade(){
                if (this.funcionalidade) {
                    this.carregarDados({treefuncionalidade:this.funcionalidade})
                    this.mostrar_tabela = false
                } else {
                    this.carregarDados({treefuncao:this.funcao})
                    this.mostrar_tabela = false
                }
            },
            analista(){
                this.filtrarDados()
                this.mostrar_tabela = false
            },
            tipo(){
                this.filtrarDados()
                this.mostrar_tabela = false
            },
            status(){
                this.filtrarDados()
                this.mostrar_tabela = false
            },
            close(){
                if (this.close){
                    this.mostrar_tabela = false
                    this.mostrar_grafico = false
                } else {
                    this.mostrar_grafico = true
                }    
            },
            mostrar_tabela(){
                this.$emit('download',this.mostrar_tabela)
            }
        }
}
</script>
